import { css, useTheme } from '@emotion/react';
import { Lock, Users } from '@phosphor-icons/react';
import { getPlaceholderUrl } from 'common/commonUtil';
import { useAccount } from 'client/lib/User';
import { Catalog, CatalogItemProps } from 'client/components/Catalog';
import { Dialog } from 'client/components/Dialog/Dialog';
import { Input } from 'client/components/Input';
import { Tag } from 'client/components/Tag';
import { Typography } from 'client/components/Typography';

export interface CoreLimitDialogProps {
  open: boolean;
  onClose: () => void;
}

export const CoreLimitDialog = ({ open, onClose }: CoreLimitDialogProps) => {
  const theme = useTheme();
  const account = useAccount();

  const accountItem: CatalogItemProps = {
    id: 'account',
    title: account?.name || '',
    subtitle: <Tag type="grey">{account?.id}</Tag>,
    image: { alt: 'account profile picture', src: getPlaceholderUrl('account', account?.id || '') },
  };

  return (
    <Dialog
      open={open}
      title="Running Deployment Limit Reached"
      description="You are currently limited to 5 simultaneously running deployments."
      icon={<Users color={theme.color.primary[100]} />}
      iconOrnament={<Lock color={theme.color.primary[100]} />}
      primaryAction={null}
      secondaryAction="Close"
      onClose={onClose}
    >
      <Typography style={{ marginBottom: 24 }}>
        Your trial account is limited to 5 simultaneously running deployments. If you are interested in lifting this restriction, please
        send us a message. Our staff are able to upgrade your account.
      </Typography>

      <Input label="Contact Us" value="hello@diploi.com" canCopy large css={inputStyle} />

      <Catalog items={[accountItem]} css={catalogStyle} />
    </Dialog>
  );
};

const catalogStyle = css`
  margin-bottom: 16px;

  svg {
    transform: translateY(2px);
    opacity: 0.8;
  }
`;

const inputStyle = css`
  margin-bottom: 16px;

  .MuiInputBase-root:not(.Mui-focused) {
    > label {
      display: none;
    }
  }
`;
